import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-light-svg-icons";
import { RevTooltip } from "@revmatics/catalyst";
import { ReactNode } from "react";

type Props = {
  title: string;
  tooltip: string;
  children: ReactNode;
};

export const TitleWrapper = ({ title, tooltip, children }: Props) => {
  return (
    <div className="space-y-4">
      <div className="flex gap-2 items-center">
        <h6>{title}</h6>
        {tooltip && (
          <RevTooltip
            content={tooltip}
            position="top"
            className="max-w-[350px]"
          >
            <FontAwesomeIcon
              icon={faCircleInfo}
              className="text-monochrome-700 text-md hover:text-primary-500"
            />
          </RevTooltip>
        )}
      </div>
      {children}
    </div>
  );
};
